import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';

import { NbToastrService } from '@nebular/theme';
import { ValidateService } from '../../../../../@core/utils/validate.service';
import { ISubscription } from 'rxjs/Subscription';

import { ApiClientService } from '../../../../../@core/services';
import { ImprovementPlanProcess } from '../models/improvement-plan-process';
@Component({
  selector: 'improvement-process-list',
  templateUrl: './improvement-process-list.component.html',
  styleUrls: ['./improvement-process-list.component.scss'],
  providers: [ValidateService],
})
export class ImprovementProcessListComponent implements OnInit, OnDestroy {
  private subscription: ISubscription;
  _processList: ImprovementPlanProcess[] = [];
  private setList: boolean = false;
  private changeList: boolean = false;
  @Input()
  set processList(value: ImprovementPlanProcess[]) {
    if (!this.changeList) {
      this.setList = true;
      if (this._processList && this._processList.length > 0) this._processList.forEach(x => this.removeProcess());

      value.forEach(x => this.addProcess(x));
      this.setList = false;
    } else this.changeList = false;
  }
  get processList() {
    return this._processList;
  }
  @Input() public editable: boolean = true;
  @Input() public fireValidationAlerts: boolean = false;
  @Input() public reference: any;

  valid: boolean;
  @Output() listValid = new EventEmitter<boolean>();
  @Output() valueChanged = new EventEmitter<ImprovementPlanProcess[]>();
  constructor(
    private validationService: ValidateService,
    private apiClient: ApiClientService,
    private toastrService: NbToastrService,
  ) {
    this.valid = true;
  }

  ngOnInit() {
    this.subscription = this.validationService.validStatus.subscribe((status: boolean) => {
      this.valid = status;
      this.listValid.emit(status);
    });
  }
  isInputValid(name: string, status: boolean) {
    this.validationService.updateFormFlag(name, status);
  }
  addProcess(process: ImprovementPlanProcess = {} as any) {
    const index = this._processList.length;
    this._processList.push(process);
    this.validationService.addInputKey(('process-' + index).toString());
    this.onValueChanged();
  }

  removeProcess() {
    if (this._processList.length > 0) {
      const index = this._processList.length - 1;
      this.validationService.removeInputKey(('process-' + index).toString());
      this._processList.pop();
      this.onValueChanged();
    }
  }
  processAchievementRemember(processId: number) {
    this.apiClient.update(`api/ImprovementPlan/Process/sendRemember/${processId}`, null).subscribe(res => {
      this.toastrService.success('تم إرسال رسائل التذكير');
    });
  }
  onValueChanged() {
    if (!this.setList) {
      this.changeList = true; // to prevent set from update current list after emit value
      this.valueChanged.emit(this._processList);
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
